import apiClient from './client'

export const coursesApi = {
  getCourses: async (params = {}) => {
    const response = await apiClient.get('/courses', { params })
    return response.data
  },

  getCourse: async (id) => {
    const response = await apiClient.get(`/courses/${id}`)
    return response.data
  },

  getCourseUnits: async (id) => {
    const response = await apiClient.get(`/courses/${id}/units`)
    return response.data
  },

  getRevisionLectures: async (id) => {
    const response = await apiClient.get(`/courses/${id}/revision-lectures`)
    return response.data
  },
}

